export const workPhaseKind = {
    Hoai: 0,
    Riba: 1,
    Sia: 2,
    None: 3
}